import { render } from "./PartnerUpdateManageView.vue?vue&type=template&id=7dd24dee&scoped=true"
import script from "./PartnerUpdateManageView.vue?vue&type=script&lang=js"
export * from "./PartnerUpdateManageView.vue?vue&type=script&lang=js"

import "./PartnerUpdateManageView.vue?vue&type=style&index=0&id=7dd24dee&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7dd24dee"]])

export default __exports__